function isNumberInput(element) {
    return element &&
        element.tagName === 'INPUT' &&
        element.type === 'number';
}

export default function disableNumberInputWheel() {
    if (typeof document === 'undefined') {
        return;
    }

    document.addEventListener('wheel', event => {
        const target = event.target;

        if (!isNumberInput(target) || document.activeElement !== target) {
            return;
        }

        // Number inputs change their value on wheel while focused; blur first so the page scrolls instead.
        target.blur();
    }, true);
}
